import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { responseInitialValues } from "@utils/response"
import { ResponseDefault, ResponsePattern } from "@utils/response/types"
import { Cliente } from "../interfaces/Cliente"

interface State {
    requestGetCliente: ResponseDefault<Cliente>
    requestGetClientes: ResponseDefault<Cliente[]>
    requestCreateCliente: ResponseDefault<any>
    requestUpdateCliente: ResponseDefault<any>
    requestDeleteCliente: ResponseDefault<any>
}

const initialState: State = {
    requestGetCliente: responseInitialValues,
    requestGetClientes: responseInitialValues,
    requestCreateCliente: responseInitialValues,
    requestUpdateCliente: responseInitialValues,
    requestDeleteCliente: responseInitialValues,
}

const requestClienteSlice = createSlice({
    name: 'requestCliente',
    initialState,
    reducers: {
        setRequestGetClienteData: (state, action: PayloadAction<ResponsePattern<Cliente>>) => {
            state.requestGetCliente.data = action.payload
            state.requestGetCliente.loading = false
            state.requestGetCliente.error = false
        },
        setRequestGetClienteLoading: (state) => {
            state.requestGetCliente.loading = true
            state.requestGetCliente.error = false
        },
        setRequestGetClienteError: (state) => {
            state.requestGetCliente.loading = false
            state.requestGetCliente.error = true
        },
        setRequestGetClienteMessage: (state, action: PayloadAction<string>) => {
            state.requestGetCliente.message = action.payload
        },
        resetRequestGetCliente: (state) => {
            state.requestGetCliente = {...responseInitialValues}
        },

        setRequestGetClientesData: (state, action: PayloadAction<ResponsePattern<Cliente[]>>) => {
            state.requestGetClientes.data = action.payload
            state.requestGetClientes.loading = false
            state.requestGetClientes.error = false
        },
        setRequestGetClientesLoading: (state) => {
            state.requestGetClientes.loading = true
            state.requestGetClientes.error = false
        },
        setRequestGetClientesError: (state) => {
            state.requestGetClientes.loading = false
            state.requestGetClientes.error = true
        },
        setRequestGetClientesMessage: (state, action: PayloadAction<string>) => {
            state.requestGetClientes.message = action.payload
        },
        resetRequestGetClientes: (state) => {
            state.requestGetClientes = {...responseInitialValues}
        },

        setRequestCreateClienteData: (state, action: PayloadAction<any>) => {
            state.requestCreateCliente.data = action.payload
            state.requestCreateCliente.loading = false
            state.requestCreateCliente.error = false
        },
        setRequestCreateClienteLoading: (state) => {
            state.requestCreateCliente.loading = true
            state.requestCreateCliente.error = false
        },
        setRequestCreateClienteError: (state) => {
            state.requestCreateCliente.loading = false
            state.requestCreateCliente.error = true
        },
        setRequestCreateClienteMessage: (state, action: PayloadAction<string>) => {
            state.requestCreateCliente.message = action.payload
        },
        resetRequestCreateCliente: (state) => {
            state.requestCreateCliente = {...responseInitialValues}
        },

        setRequestUpdateClienteData: (state, action: PayloadAction<any>) => {
            state.requestUpdateCliente.data = action.payload
            state.requestUpdateCliente.loading = false
            state.requestUpdateCliente.error = false
        },
        setRequestUpdateClienteLoading: (state) => {
            state.requestUpdateCliente.loading = true
            state.requestUpdateCliente.error = false
        },
        setRequestUpdateClienteError: (state) => {
            state.requestUpdateCliente.loading = false
            state.requestUpdateCliente.error = true
        },
        setRequestUpdateClienteMessage: (state, action: PayloadAction<string>) => {
            state.requestUpdateCliente.message = action.payload
        },
        resetRequestUpdateCliente: (state) => {
            state.requestUpdateCliente = {...responseInitialValues}
        },

        setRequestDeleteClienteData: (state, action: PayloadAction<any>) => {
            state.requestDeleteCliente.data = action.payload
            state.requestDeleteCliente.loading = false
            state.requestDeleteCliente.error = false
        },
        setRequestDeleteClienteLoading: (state) => {
            state.requestDeleteCliente.loading = true
            state.requestDeleteCliente.error = false
        },
        setRequestDeleteClienteError: (state) => {
            state.requestDeleteCliente.loading = false
            state.requestDeleteCliente.error = true
        },
        setRequestDeleteClienteMessage: (state, action: PayloadAction<string>) => {
            state.requestDeleteCliente.message = action.payload
        },
        resetRequestDeleteCliente: (state) => {
            state.requestDeleteCliente = {...responseInitialValues}
        },
    }
})

const actions = requestClienteSlice.actions

export const requestGetClienteActions = {
    data: actions.setRequestGetClienteData,
    loading: actions.setRequestGetClienteLoading,
    error: actions.setRequestGetClienteError,
    message: actions.setRequestGetClienteMessage,
    reset: actions.resetRequestGetCliente,
}

export const requestGetClientesActions = {
    data: actions.setRequestGetClientesData,
    loading: actions.setRequestGetClientesLoading,
    error: actions.setRequestGetClientesError,
    message: actions.setRequestGetClientesMessage,
    reset: actions.resetRequestGetClientes,
}

export const requestCreateClienteActions = {
    data: actions.setRequestCreateClienteData,
    loading: actions.setRequestCreateClienteLoading,
    error: actions.setRequestCreateClienteError,
    message: actions.setRequestCreateClienteMessage,
    reset: actions.resetRequestCreateCliente,
}

export const requestUpdateClienteActions = {
    data: actions.setRequestUpdateClienteData,
    loading: actions.setRequestUpdateClienteLoading,
    error: actions.setRequestUpdateClienteError,
    message: actions.setRequestUpdateClienteMessage,
    reset: actions.resetRequestUpdateCliente,
}

export const requestDeleteClienteActions = {
    data: actions.setRequestDeleteClienteData,
    loading: actions.setRequestDeleteClienteLoading,
    error: actions.setRequestDeleteClienteError,
    message: actions.setRequestDeleteClienteMessage,
    reset: actions.resetRequestDeleteCliente,
}

export default requestClienteSlice.reducer